import ALGOLIA_INDICES from './algolia'
import CONTENT_SERVICE from './contentService'
import ROUTES from './routes'
import SITE_CONFIG from './siteConfig'
import SLUG from './slug'

export { CONTENT_SERVICE, SITE_CONFIG, ROUTES, SLUG, ALGOLIA_INDICES }
